export const TEST_IDS = {
  successTitle: 'successTitle',
  successSubtitle: 'successSubtitle',
  calendarLinksSection: 'calendarLinksSection',
  successImage: 'successImage',
  address: 'address',
  customerLastName: 'customerLastName',
  appointmentDate: 'appointmentDate',
  treatmentName: 'treatmentName',
  treatmentCardName: 'treatmentCardName',
  treatmentCardDuration: 'treatmentCardDuration',
  treatmentsContainer: 'treatmentsContainer',
  treatmentCategory: 'treatmentCategory',
  buttonBook: 'buttonBook',
  buttonBack: 'buttonBack',
  nextButton: 'nextButton',
  statusBarDesktop: 'statusBarDesktop',

  requestNewOtp: 'request-new-otp',
  otpInput: `otp-input`, // always add index, for example `otp-input-0`
  phoneInput: 'phone-input',
  changePhoneNumberLink: 'change-phone-number-link',
  continueAsNewPatient: 'continue-as-new-patient',
  selectPatientAccount: 'select-patient-account',
  selectPatientContainer: 'select-patient-container',
  addToCalendarButton: 'add-to-calendar-button',
  anamnesisButton: 'anamnesis-button',
  healthAssistantButton: 'health-assistant-button',
  bookingInfo: 'bookingInfo',
  practitionerCard: 'practitionerCard',
  dataSelectedPractitioner: 'data-selected-practitioner',
  dataSelectedPractitionerType: 'data-selected-practitioner-type',

  toggleClinicsNearby: 'toggle-clinics-nearby',
  toggleMoreAppointments: 'toggle-clinics-nearby',

  slotSelector: 'populated-appointment-slot',
  selectedSlot: '[class*="Slots-selected"] p',
  selectAllCheckbox: '[data-test="select-all-checkbox"]',
  nextWeekButton: 'svg[data-test=next-week]',

  districtContainer: 'district-container',
  clinicContainer: 'clinic-container',
}
